import { Minus } from "lucide-react";

const MUTED = "var(--color-muted-foreground)";

const FILLED = "var(--color-primary)";

const PRIORITY_BARS: Record<string, number> = {
  urgent: 1,
  asap: 2,
  stat: 3,
};

export function TaskPriorityIcon({ priority, size = 14 }: { priority: string | undefined; size?: number }) {
  if (!priority || priority === "routine") {
    return <Minus size={size} className="shrink-0 text-muted-foreground/40" />;
  }

  const bars = PRIORITY_BARS[priority];
  if (!bars) {
    return <Minus size={size} className="shrink-0 text-muted-foreground/40" />;
  }

  return (
    <svg width={size} height={size} viewBox="0 0 14 14" className="shrink-0" aria-hidden="true">
      <rect
        x="1.5"
        y="9"
        width="3"
        height="2.5"
        rx="0.5"
        fill={bars >= 1 ? FILLED : MUTED}
        opacity={bars >= 1 ? 1 : 0.25}
      />
      <rect
        x="5.5"
        y="5.5"
        width="3"
        height="6"
        rx="0.5"
        fill={bars >= 2 ? FILLED : MUTED}
        opacity={bars >= 2 ? 1 : 0.25}
      />
      <rect
        x="9.5"
        y="2.5"
        width="3"
        height="9"
        rx="0.5"
        fill={bars >= 3 ? FILLED : MUTED}
        opacity={bars >= 3 ? 1 : 0.25}
      />
    </svg>
  );
}
